import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import TableIdButton from "@lib/components/MiniComponents/Buttons/TableIdButton";
import { shortenString } from "@lib/helpers/StringHelper";
import { ColumnConfig, generateColumns } from "@lib/helpers/TableHelper";
import { TableColumnsProps } from "@lib/types/General";
import { XAICall } from "@lib/types/xAI";
import { Tooltip } from "antd";
import {
  CoinPriceTextFormat,
  Keywords,
  XAICallStatusTag,
  XAIClientMoodTag,
  XAIDisconnectionResultTag,
} from "@lib/components/MiniComponents/Others";
import CallLength from "@lib/components/MiniComponents/Others/CallLength";
import VoicePlayer from "@lib/components/MiniComponents/Voice";

type Props<T> = TableColumnsProps<T>;

const getColumns = <T extends XAICall>(props: Props<T>): ColumnsType<T> => {
  // const { messages } = props;

  const columnsConfig: ColumnConfig<T>[] = [
    {
      title: "common.callId",
      dataIndex: "callId",
      width: "130px",
      render: (_, r) => (
        <TableIdButton text={`${shortenString(r?.callId || "")}`} />
      ),
    },

    {
      title: "common.updatedAt",
      dataIndex: "updatedAt",
      width: "150px",
      render: (d) => dayjs(d).format("DD/MM/YYYY HH:mm"),
    },

    {
      title: "common.callStatus",
      dataIndex: "callStatus",
      width: "150px",
      render: (_, r) =>
        r?.callStatus ? (
          <XAICallStatusTag status={r.callStatus} size="small" />
        ) : (
          "-"
        ),
    },

    {
      title: "common.clientMood",
      dataIndex: "clientMood",
      width: "150px",
      render: (_, r) =>
        r?.clientMood ? (
          <XAIClientMoodTag mood={r.clientMood} size="small" />
        ) : (
          "-"
        ),
    },

    {
      title: "common.disconnectionResult",
      dataIndex: "disconnectionResult",
      width: "150px",
      render: (_, r) =>
        r?.disconnectionResult ? (
          <XAIDisconnectionResultTag
            result={r.disconnectionResult}
            size="small"
          />
        ) : (
          "-"
        ),
    },

    {
      title: "common.keywords",
      dataIndex: "keywords",
      width: "150px",
      filterType: "search",
      render: (d) => <Keywords keywords={d} />,
    },

    {
      title: "common.callCost",
      dataIndex: "callCost",
      width: "150px",
      render: (_, r) => (
        <CoinPriceTextFormat
          amount={Number(r?.callCost || 0)}
          showCurrencySymbol
        />
      ),
    },

    {
      title: "common.duration",
      dataIndex: "durationMs",
      width: "150px",
      render: (_, r) => <CallLength callLength={Number(r?.durationMs || 0)} />,
    },

    {
      title: "common.voiceFile",
      dataIndex: "voiceFile",
      width: "200px",
      render: (_, r) => (
        <VoicePlayer
          voiceFile={r?.voiceFile}
          showDownload={false}
          title={false}
        />
      ),
    },

    {
      title: "common.summary",
      dataIndex: "summary",
      width: "200px",
      render: (d) => <Tooltip title={d}>{shortenString(d, 30)}</Tooltip>,
    },
  ];

  return generateColumns(props, columnsConfig);
};

export default getColumns;
